import { render } from "./TrainingPhrasesReport.vue?vue&type=template&id=1880b66f&scoped=true"
import script from "./TrainingPhrasesReport.vue?vue&type=script&lang=js"
export * from "./TrainingPhrasesReport.vue?vue&type=script&lang=js"

import "./TrainingPhrasesReport.vue?vue&type=style&index=0&id=1880b66f&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1880b66f"]])

export default __exports__